// Meta Pixel event helper.
//
// The base pixel (init + PageView) is loaded in public/index.html and the
// Purchase event fires in PaymentSuccess.tsx. This helper adds the funnel
// steps in between, so Ads Manager can show where campaign visitors drop
// off: landing → chapter read → email submitted → buy click → purchase.
//
// fbq may be absent (ad-blockers, localhost) — every call is guarded and
// failure is silent; analytics must never break the reading experience.

type FbqWindow = Window & {
  fbq?: (command: string, event: string, params?: Record<string, unknown>) => void;
};

function fbq(event: string, params?: Record<string, unknown>): void {
  try {
    const w = window as FbqWindow;
    if (typeof w.fbq !== "function") return;
    w.fbq("track", event, params);
  } catch {
    /* analytics must never throw */
  }
}

// Fired once per chapter per page-load — a visitor opening chapter content.
const seenChapters = new Set<number>();
export function trackChapterView(chapter: number): void {
  if (seenChapters.has(chapter)) return;
  seenChapters.add(chapter);
  fbq("ViewContent", { content_name: `chapter-${chapter}` });
}

// Fired when a visitor submits their email for a magic link — the moment
// an anonymous reader becomes a contactable lead.
export function trackLead(): void {
  fbq("Lead");
}

// Fired when a signed-in reader clicks the buy button on the paywall.
export function trackInitiateCheckout(): void {
  fbq("InitiateCheckout", { currency: "ILS", value: 89 });
}
